export const tabelaPremiacaoFilterConfig = [
  {
    id: 'Nome',
    type: 'text',
    label: 'Nome',
    placeholder: 'Digite o nome da tabela'
  },
  {
    id: 'Segmento',
    type: 'searchSelect',
    label: 'Segmento',
    placeholder: 'Selecione um ou mais segmentos',
    isMulti: true,
    showSelectAll: true,
    options: []
  },
  {
    id: 'Ativo',
    type: 'checkbox',
    label: 'Ativo'
  }
];
